<script>
import axios from 'axios';
export default {
  props: ['url', 'pageId', 'increment', 'activeBlogger'],
  data() {
    return {
      postsFromBlog: [],
      currentIncrement: parseInt(this.increment),
      noResponse: false,
    };
  },
  mounted() {
    let data = {
      pageid: this.pageId,
      increment: this.increment,
      blogger: this.activeBlogger,
    };
    axios.post(this.url, data).then((response) => {
      this.postsFromBlog = response.data.posts;
    });
  },
  methods: {
    async showMore() {
      this.currentIncrement += parseInt(this.increment);
      let data = {
        pageid: this.pageId,
        increment: this.currentIncrement,
        blogger: this.activeBlogger,
      };
      axios.post(this.url, data).then((response) =>
        response.data.posts.map((post, index) => {
          index >= this.currentIncrement - parseInt(this.increment) &&
            this.postsFromBlog.push(post);
          if (this.currentIncrement > response.data.posts.length) {
            this.noResponse = true;
          }
        })
      );
    },
  },
};
</script>

<template>
  <ul class="list-unstyled">
    <li v-for="post in postsFromBlog" class="blog-post">
      <div class="row">
        <div class="col-12 col-md-3">
          <img v-if="post" :src="post.image" class="lazyloaded" />
        </div>
        <div class="col-12 col-md-9 info">
          <h3 class="heading-level-3">
            <a :href="post.url">{{ post.title }}</a>
          </h3>
          <div class="mb-0 mt-0 small-font">
            {{ post.published }}, {{ post.author }}
          </div>
          <div class="mb-0 mt-2">{{ post.preamble }}</div>
        </div>
      </div>
    </li>
    <div class="row mt-4 mb-5">
      <div class="col-12 text-center">
        <button v-if="!noResponse" @click="showMore" class="button-small">
          Visa fler
        </button>
      </div>
    </div>
  </ul>
</template>
